export enum INSTANT_ARCHIVING_CONFIG_ACTION {
  Create = 'create',
  Update = 'update',
  Delete = 'delete'
}

export type RestoreOperation = {
  id: string,
  restore_indices: Array<RestoreIndex>
  timestamp_from: string,
  timestamp_to: string,
  restored_at: string,
  index_failures: number,
  partially_restored: boolean,
  restored_documents: number,
};

export type RestoreIndex = {
  index_set_id: string,
  index_name: string
}

export type InstantArchive = {
  id: string,
  archive_config_id: string,
  message_count: number,
  archive_name: string,
  timestamp_from: string,
  timestamp_to: string,
  stream_map: {
    [key: string]: string
  },
  restore_history: Array<RestoreOperation>,
}

export type InstantArchivingConfig = {
  archive_name: string,
  stream_ids: Array<string>,
  retention_time: string,
  id: string,
  enabled: boolean
}

export enum JobStatus {
  Cancelled = 'cancelled',
  Complete = 'complete',
  Error = 'error',
  Paused = 'paused',
  Runnable = 'runnable',
  Running = 'running',
}

export enum JobType {
  Restore = 'restore',
  Delete = 'delete',
}

export type InstantArchiveJob = {
  id: string,
  job_type: JobType,
  archive: Array<string>,
  is_cancelable: boolean,
  target_index_name: string,
  status: JobStatus,
  percent_done: number,
  started_at: string,
};
